// Types
import type { TOutboxEmail } from '~/modules/opportunities/automated-email/types';

/** Live countdown label for `send_at` (ISO 8601) vs `nowMs`. */
export const getFormattedSendingCountdown = (
  sendAtIso: string | null | undefined,
  nowMs: number
): string => {
  if (!sendAtIso) {
    return '—';
  }

  const targetMs: number = new Date(sendAtIso).getTime();

  if (!Number.isFinite(targetMs)) {
    return '—';
  }

  const diffMs: number = targetMs - nowMs;

  if (diffMs <= 0) {
    return 'Sending soon';
  }

  const totalSeconds: number = Math.floor(diffMs / 1000);
  const days: number = Math.floor(totalSeconds / 86400);
  const hours: number = Math.floor((totalSeconds % 86400) / 3600);
  const mins: number = Math.floor((totalSeconds % 3600) / 60);
  const secs: number = totalSeconds % 60;

  const pad2 = (n: number): string => String(n).padStart(2, '0');

  if (days > 0) {
    return `${days}d ${pad2(hours)}:${pad2(mins)}:${pad2(secs)}`;
  }

  return `${pad2(hours)}:${pad2(mins)}:${pad2(secs)}`;
};

export const getOutboxSendAtIsoForCountdown = (
  email: Pick<TOutboxEmail, 'send_at'>
): string => email.send_at ?? '';
